/**
 * Created by User on 10/1/2560.
 */
import { Component, ChangeDetectorRef, OnInit, Renderer2, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MomentPipe } from 'app/shared/moment.pipe';
import { WaitForImportComponent } from '../google-drive/wait-for-import.component';
import { SharingComponent } from '../sharing/sharing.component';
import { TranslateService } from '@ngx-translate/core';
import { Mimetype } from 'app/shared/mimetype';
import { OneDrive } from '../onedrive/onedrive.service';
import { Path } from 'app/shared/path';
import { Toast } from 'app/shared/toast/toast';
import { DeleteCommentComponent } from '../delete-comment/delete-comment.component';
import { WatermarkDMS, zDoxItem } from '../../shared/types';
import { DocumentData } from '../annotation-controller/document-data.type';
import { ViewerTopBarConfig } from '../viewer-controller/viewer-top-bar/viewer-top-bar.component';
import { CannotPreviewViewerContent, FileViewerConfig, MailViewerContent, ViewerContent } from '../viewer-controller/file-viewer/file-viewer.type';
import { ViewerInfoPanelComponent } from '../viewer-controller/viewer-info-panel/viewer-info-panel.component';
import { InfoPanelConfig, defaultConfig, InfoPanel_Details, InfoPanel_Comments } from '../viewer-controller/viewer-info-panel/viewer-info-panel.types';
import * as $ from 'jquery';
import { MetadataService } from '../viewer-controller/viewer-info-panel/services/metadata.service';
import { ViewerControllerComponent } from '../viewer-controller/viewer-controller.component';
import {SocialLogin} from "../../account/social-login";

declare let moment: any;
declare const google: string;

@Component({
   selector: 'app-viewer',
   templateUrl: './viewer.component.html',
   styleUrls: ['./viewer.component.css'],
})
export class ViewerComponent implements OnInit {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   doc: zDoxItem | any = {};
   imageUrl: string;
   imgUrl: string;
   pdfUrl: SafeResourceUrl;
   videoUrl: string;
   audioUrl: string;
   post = 'ส่ง';
   lastModified: { when: string; };
   error: string;

   errorMessage: string;
   doc_id: any;
   // size: any = '';
   readonly size = 5242880;
   path: any;
   lenght_property: any;
   success: any;
   comment: any;
   loaded = false;

   protected showSideInfo = false;

   isBusiness: boolean;
   show: boolean;
   action_status = true;
   saveText = 'Save';
   form: any;
   canPrint: boolean;
   docUrl: string;
   documentData: DocumentData;
   checkTypeForHide: boolean;
   isStartFlow: boolean;
   isPermissions: any;
   isOpen = false;
   watermark: WatermarkDMS;
   statusDocument: string;
   owner: string;
   isShowStartFlow = false;

   ////////////////////////////

   protected topBarConfig: ViewerTopBarConfig = {
      viewMode: "default",
      showBackButton: true,
      showLogo: false,
      // Hide the buttons for now (until the document is loaded)
      showShareButton: true,
      showStartFlowButton: false,
      showOpenWithButton: false,
      openWithGoogle: undefined,
      openWithMicrosoft: undefined,
      showDownloadButton: false,
   };
   protected viewerConfig: FileViewerConfig;
   protected infoPanelConfig: InfoPanelConfig = defaultConfig;

   @ViewChild(ViewerControllerComponent) viewerController: ViewerControllerComponent;
   dl = true;
   cancel = false;
   selectedValue: string;

   shared: boolean;
   access_token: string;

   constructor(private route: ActivatedRoute,
               private router: Router,
               public service: IdexService,
               private onedrive: OneDrive,
               private sanitizer: DomSanitizer,
               public dialog: MatDialog,
               public metadataService: MetadataService,
               private renderer: Renderer2,
               private translate: TranslateService,
               private changeDetector: ChangeDetectorRef,
               private toast: Toast,
               private socialLogin: SocialLogin) {
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   ngOnInit() {
      if (sessionStorage.getItem('shared')) {
         this.shared = true;
      }

      if (!this.service.shareDocId) {
         this.service.shareId = sessionStorage.getItem('shareId');
         this.service.shareDocId = sessionStorage.getItem('shareDocId');
         this.service.isDownload = sessionStorage.getItem('isDownload') === 'true';
         this.service.permissionLevel = parseInt(sessionStorage.getItem('permissionLevel'), 10);

         sessionStorage.removeItem('shareId');
         sessionStorage.removeItem('shareDocId');
         sessionStorage.removeItem('isDownload');
         sessionStorage.removeItem('permissionLevel');
      }

      this.route.params.forEach((params: Params) => {
         this.checkTypeForHide = true;
         this.doc_id = params['id'];
         this.isShowStartFlow = sessionStorage.getItem('isShowStartFlow') === 'true';
         this.dl = sessionStorage.getItem('dl') !== null && sessionStorage.getItem('dl') === 'false' ? false : true;
         this.checkDevice('idex://file?key=' + this.doc_id, this.doc_id);
      });
      window.addEventListener('message', () => {
         if (this.onedrive.action === 'file') {
            if (this.action_status) {
               this.action_status = false;
            }
         }
      });
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      sessionStorage.setItem('shareId', this.service.shareId);
      sessionStorage.setItem('shareDocId', this.service.shareDocId);
      sessionStorage.setItem('isDownload', this.service.isDownload.toString());
      sessionStorage.setItem('permissionLevel', this.service.permissionLevel.toString());
   }

   deletefile(): void {
      this.service.deleteFiles(this.doc_id)
         .subscribe(
            data => {
               const url = Path.combine('/files', this.path);
               this.router.navigate([url]);
            },
            error => {
               this.errorMessage = <any>error;
            });
   }


   getDocument(): void {
      this.service.getDocument(this.doc_id)
         .subscribe((data: zDoxItem) => {
               this.doc = data;
               this.infoPanelConfig = this.setInfoPanelDetails(this.doc, this.infoPanelConfig);
               // In case that the document is loaded after the comment, the comments will be undefined.
               // Thus, we need to update the comment's permission.
               const updateCommentPermission = () => {
                  let tmpConfig = this.infoPanelConfig;
                  tmpConfig.tabs.comments.canAdd = this.doc.permissions?.create;
                  tmpConfig.tabs.comments.canEdit = this.doc.permissions;
                  tmpConfig.tabs.comments.canDelete = this.doc.permissions;
                  return {...tmpConfig}
               }
               this.infoPanelConfig = updateCommentPermission();
               this.show = Mimetype.canEdit(this.doc);
               this.canPrint = Mimetype.canPrint(this.doc);
               this.isStartFlow = data.startFlow;
               this.isPermissions = data.permissions;
               this.watermark = data.watermark;
               this.statusDocument = data.statusDocument;
               this.owner = data.creator.id;
               this.initDocument();
               this.metadataService.initMetadata(data);
            },
            (error: any) => {
               this.loaded = true;
                  setTimeout(() => {
                     this.router.navigate(['/dashboard']);
                 }, 2000);
            });
   }

   private setInfoPanelDetails(doc: zDoxItem, config = defaultConfig): InfoPanelConfig {
      if (!doc) {
         return {...config};
      }
      const description: InfoPanel_Details["description"] = {
         description: doc.description,
         canEdit: doc.permissions?.write,
         showDescription: !!doc.permissions,
      };
      const properties: InfoPanel_Details["properties"] = {
         owner: doc.creator && doc.creator.name,
         created: doc.created,
         modified: doc.modified,
         type: doc.mimeTypeName,
         size: doc.size,
         location: doc.path,
      };
      config.tabs.details.description = description;
      config.tabs.details.properties = properties;
      return {...config};
   }

   initDocument(): void {
      const token = this.service.user.token;
      const mimeType = this.doc.mimeType;
      const fileName = this.doc.name;
      const typeFile = this.doc.type;
      const docId = this.doc_id;
      const url = this.service.url + '/content?id=' + this.doc_id + '&token=' + token;

      // PDFTron
      if (mimeType === 'application/pdf'
         || ((mimeType === 'application/vnd.oasis.opendocument.text'
            || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            || mimeType === 'application/msword'
            || mimeType === 'application/vnd.ms-excel'
            || mimeType === 'image/tiff'
            || mimeType === 'application/vnd.ms-powerpoint'
            || mimeType === 'application/octet-stream') && this.doc.size <= this.size)) {
         const file = encodeURIComponent(this.service.url + '/content?id=' + this.doc_id + '&token=' + token + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = url + '&isPdfTron=true&' + Date.now();
         this.extracted(this.docUrl, fileName, typeFile, mimeType, docId);

         // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
         // For example, right now (19 Apr 2024), "document.docx" in zDOX is actually PDF file, not Word file.
         this.documentData.fileFormat = "pdf";
         this.checkTypeForHide = false;
         this.viewerConfig = {
            viewerType: "document",
            content: this.documentData,
         };
      }
      // Image (supported by PDFTron)
      else if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
         this.imageUrl = url + '&' + Date.now();
         this.extracted(this.imageUrl, fileName, typeFile, mimeType, docId);
         this.checkTypeForHide = false;
         this.viewerConfig = {
            viewerType: "document",
            content: this.documentData,
         };
      }
      // Image (not supported by PDFTron)
      else if (mimeType === 'image/gif' || mimeType === 'image/bmp') {
         this.imgUrl = 'typeImage';
         this.service.toDataURL(this.service.url + '/content?id=' + this.doc_id + '&' + Date.now(), (dataUrl) => {
            this.viewerConfig = {
               viewerType: "image",
               content: dataUrl,
            };
         });
      }
      // SVG
      else if (mimeType === 'image/svg+xml') {
         const svgUrl = '/content?id=' + this.doc_id + '&token=' + token;
         this.service.get(svgUrl, {responseType: 'text'}).subscribe(data => {
            this.loaded = true;
            this.viewerConfig = {
               viewerType: "svg",
               content: this.sanitizer.bypassSecurityTrustHtml(data),
            };
         });
      }
      // Video
      else if (mimeType.indexOf('video/') === 0
         && mimeType !== 'video/mpeg' && mimeType !== 'video/avi'
         && mimeType !== 'video/msvideo' && mimeType !== 'video/x-msvideo'
         && mimeType !== 'video/quicktime' && mimeType !== 'video/x-ms-wmv'
         && mimeType !== 'video/x-flv' && mimeType !== 'video/ogg') {
         this.videoUrl = 'typeVideo';
         this.service.toDataURL(this.service.url + '/content?id=' + this.doc_id + '&' + Date.now(), (dataUrl: ViewerContent<"video">) => {
            this.viewerConfig = {
               viewerType: "video",
               content: dataUrl,
            };
         });
      }
      // Audio
      else if (mimeType.indexOf('audio/') === 0
         && mimeType !== 'audio/basic'
         && mimeType !== 'audio/x-ms-wma'
         && mimeType !== 'audio/vorbis') {
         this.audioUrl = 'typeAudio';
         this.service.toDataURL(this.service.url + '/content?id=' + this.doc_id + '&' + Date.now(), (dataUrl: ViewerContent<"audio">) => {
            this.viewerConfig = {
               viewerType: "audio",
               content: dataUrl,
            };
         });
      }
      // Plain Text (.txt, .xml)
      else if (mimeType.indexOf('text/') === 0 || mimeType === 'application/xml') {
         const txtUrl = '/content?id=' + this.doc_id;
         this.service.get(txtUrl, {responseType: 'text'}).subscribe(data => {
            this.loaded = true;
            this.viewerConfig = {
               viewerType: "text",
               content: data,
            };
         });
      }
      // Email (.eml)
      else if (mimeType === 'message/rfc822') {
         const msgUrl = '/content?id=' + this.doc_id;
         this.service.get(msgUrl).subscribe((data: any) => {
            data.from = this.formatAddress(data.from);
            data.to = this.formatAddress(data.to);
            if (data.cc) { data.cc = this.formatAddress(data.cc); }
            if (data.html) {
               data.html = this.sanitizer.bypassSecurityTrustResourceUrl('data:text/html,' + data.html);
            }
            this.loaded = true;
            this.viewerConfig = {
               viewerType: "mail",
               content: <MailViewerContent> {
                  mail: data,
                  doc: this.doc,
               },
            };
         }, error => {
            this.error = error;
            this.loaded = true;
         });
      }
      // Other/cannot preview
      else {
         this.loaded = true;

         this.viewerConfig = {
            viewerType: "other",
            content: <CannotPreviewViewerContent> {
               iconPath: Mimetype.getIcon(this.doc),
               fileName: this.doc.name,
               fileSizeByte: this.doc.size,
               allowDownload: !this.shared || (this.shared && this.service.isDownload),
            }
         };
      }
      const fmt = new MomentPipe();
      this.lastModified = { when: fmt.transform(this.doc.modified) };

      // SET VIEWER TOP-BAR CONFIG
      this.topBarConfig.fileName = fileName;
      this.topBarConfig.lastModifiedTime = this.lastModified.when;
      this.topBarConfig.showDownloadButton = (!this.shared || (this.shared && this.service.isDownload)) && this.checkTypeForHide;
      this.topBarConfig.showStartFlowButton = this.isShowStartFlow;
      this.topBarConfig.showOpenWithButton = this.show;
      this.topBarConfig.openWithMicrosoft = {
         iconPath: this.doc.openWithIcon,
         name: this.doc.openWith,
      };
      this.topBarConfig.openWithGoogle = {
         iconPath: this.doc.openWithIconGoogle,
         name: this.doc.openWithGoogle,
      };
   }

   private extracted(url, fileName, typeFile, mimeType, docId) {

      this.documentData = {
         'url': url,
         'fileName':encodeURIComponent(fileName),
         'type': typeFile,
         'mimeType': mimeType,
         'docId': docId,
         'path': this.doc.path,
         'statusStartFlow': this.isStartFlow,
         'isPermissions': this.isPermissions,
         'watermark': this.watermark,
         'allowDownloadAndPrint': undefined,
         'actionType': 'dms',
         'statusDocument': this.statusDocument,
         'owner': this.owner,
         'lastDocVersion': this.doc.version,
      };
      this.loaded = true;
   }

   private formatAddress(array: any[]): string {
      let s = '';
      array.forEach(addr => {
         if (s.length > 0) { s += ', '; }
         if (addr.name) {
            s += '<b>' + addr.name + '</b> ';
         }
         s += '&lt;' + addr.address + '&gt;';
      });
      return s;
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.cancel = false;
         that.changeDetector.detectChanges();
      });

      setTimeout(() => {
         if (!this.loaded) {
            this.loaded = true;
            this.cancel = true;
         }
      }, 20000);
   }

   openAttach(a: any) {
      const url = this.service.url + '/attachment?id=' + this.doc.id + '&aid=' + a.id + '&token=' + this.service.user.token;
      window.open(url, a.id || this.doc.id);
   }

   download() {
      location.href = this.service.downloadFileUrl(this.doc.id) + '&token=' + this.service.user.token;
   }

   canDeactivate() {
      return this.viewerController.canDeactivate();
   }

   back() {
      let url = localStorage.getItem('url');
      url = decodeURIComponent(url);
      localStorage.removeItem('pdfjs.history');
      if (url) {
         const path = url;
         const search = '/search';
         if (path.startsWith(search)) {
            const param = path.substring(path.indexOf('=') + 1);
            this.router.navigate([search], {queryParams: {q: param}});
            if (!this.viewerController?.fileViewer?.pdfTronComp) {
               localStorage.removeItem('url');
            }
            return;
         }
         if (url === 'null' || !url) {
            url = localStorage.getItem('callback-url')
         }
         this.router.navigate([url]);
         if (!this.viewerController?.fileViewer?.pdfTronComp) {
            localStorage.removeItem('url');
         }
         sessionStorage.setItem('verify', 'true');
      } else {
         this.router.navigate(['files']);
      }
   }

   linkify(s: string): string {
      if (!s) {
         return s;
      }
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      // www. sans http:// or https://
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      // Email addresses *** here I've changed the expression ***
      const emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
      return s.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
         .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
         .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
   }

   selectOption(value: any) {
      (<HTMLInputElement>document.getElementById('settype_btn')).disabled = value === '';
   }

   addElement(itemlist: any): void {

      const div1 = document.createElement('DIV');
      const table = document.createElement('TABLE');
      const tableBody = document.createElement('TBODY');
      table.style.width = 'auto';
      table.appendChild(tableBody);
      // for (let key in itemlist)
      for (let key = 0; key < itemlist.length; key++) {

         const tr = document.createElement('TR');
         const br = document.createElement('BR');
         tableBody.appendChild(tr);
         tableBody.appendChild(br);

         for (let r = 0; r < 2; r++) {
            const td = document.createElement('TD');
            if (r === 0) {
               if (itemlist[key].mandatory === true) {
                  const span = document.createElement('SPAN');
                  const dot = document.createElement('SPAN');
                  dot.style.color = 'red';
                  const dottext = document.createTextNode('*');
                  const text = document.createTextNode(itemlist[key].label + ' : ');
                  dot.appendChild(dottext);
                  span.appendChild(dot);
                  span.appendChild(text);
                  td.appendChild(span);
               } else {
                  td.appendChild(document.createTextNode(' ' + itemlist[key].label + ' : '));
               }
               td.style.textAlign = 'right';
               td.style.paddingRight = '5px';
               td.style.fontSize = '15';
            } else {
               if (itemlist[key].dataType === 'd:text') {
                  if (itemlist[key].multiValued === true) {
                     const selectdropdown = document.createElement('SELECT');
                     selectdropdown.setAttribute('id', key.toString());
                     selectdropdown.style.width = '200px';

                     selectdropdown.style.borderRadius = '5px';
                     selectdropdown.style.border = '1px solid #9a9898';
                     selectdropdown.style.fontSize = '15';
                     // selectdropdown.setAttribute("size",'2');
                     // (<HTMLInputElement>selectdropdown).multiple = true;
                     selectdropdown.setAttribute('name', itemlist[key].id);
                     if (itemlist[key].mandatory === false) {
                        const option = document.createElement('OPTION');
                        option.setAttribute('value', '');
                        option.innerHTML = 'Please select...';
                        selectdropdown.appendChild(option);
                     }
                     for (let loop = 0; loop < itemlist[key].listValue.length; loop++) {
                        const option = document.createElement('OPTION');
                        option.setAttribute('value', itemlist[key].listValue[loop]);
                        option.innerHTML = itemlist[key].listValue[loop];

                        selectdropdown.appendChild(option);
                     }
                     if (itemlist[key].value != null) {
                        (<HTMLInputElement>selectdropdown).value = itemlist[key].value[0];
                     }

                     td.appendChild(selectdropdown);
                  } else {
                     const input = document.createElement('INPUT');
                     input.setAttribute('type', 'text');
                     input.setAttribute('id', key.toString());
                     input.setAttribute('name', itemlist[key].id);
                     input.style.width = '200px';
                     input.style.borderRadius = '5px';
                     input.style.border = '1px solid #9a9898';
                     input.style.fontSize = '15';
                     (<HTMLInputElement>input).value = itemlist[key].value;
                     if (itemlist[key].mandatory === true) {

                        (<HTMLInputElement>input).required = true;
                     }
                     input.addEventListener('keyup', (event) => {
                        if ((<HTMLInputElement>input).value.trim() === '') {
                           (<HTMLInputElement>input).value = '';
                        }
                     });
                     if (itemlist[key].constraints !== null) {
                        // (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                        // (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                        if (itemlist[key].constraints.expression != null) {
                           (<HTMLInputElement>input).pattern = itemlist[key].constraints.expression;
                        } else {
                           (<HTMLInputElement>input).maxLength = itemlist[key].constraints.maxLength;
                           (<HTMLInputElement>input).minLength = itemlist[key].constraints.minLength;
                        }
                     }
                     td.appendChild(input);
                  }
               } else if (itemlist[key].dataType === 'd:int') {
                  const input = document.createElement('INPUT');
                  input.setAttribute('type', 'text');
                  input.setAttribute('id', key.toString());
                  input.setAttribute('name', itemlist[key].id);
                  input.setAttribute('pattern', '[0-9]*');
                  input.style.width = '200px';
                  input.style.borderRadius = '5px';
                  input.style.border = '1px solid #9a9898';
                  input.style.fontSize = '15';
                  (<HTMLInputElement>input).value = itemlist[key].value;
                  if (itemlist[key].mandatory === true) {
                     (<HTMLInputElement>input).required = true;
                  }
                  if (itemlist[key].constraints !== null) {
                     (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                     (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                     (<HTMLInputElement>input).maxLength = itemlist[key].constraints.maxLength;
                     (<HTMLInputElement>input).minLength = itemlist[key].constraints.minLength;
                     (<HTMLInputElement>input).pattern = itemlist[key].constraints.expression;
                  }
                  td.appendChild(input);

               } else if (itemlist[key].dataType === 'd:double') {
                  const input = document.createElement('INPUT');
                  input.setAttribute('type', 'number');
                  input.setAttribute('pattern', '[0-9]+(.[0-9]+)?$');
                  input.setAttribute('step', 'any');
                  input.setAttribute('id', key.toString());
                  input.setAttribute('name', itemlist[key].id);
                  input.style.width = '200px';
                  input.style.borderRadius = '5px';
                  input.style.border = '1px solid #9a9898';
                  input.style.fontSize = '15';
                  (<HTMLInputElement>input).value = itemlist[key].value;

                  if (itemlist[key].mandatory === true) {
                     (<HTMLInputElement>input).required = true;
                  }
                  if (itemlist[key].constraints !== null) {
                     // if (itemlist[key].constraints.expression != null) {
                     //     (<HTMLInputElement>input).pattern = itemlist[key].constraints.expression;
                     // } if (itemlist[key].constraints.maxLength != null) {
                     //     (<HTMLInputElement>input).maxLength = itemlist[key].constraints.maxLength;
                     //     (<HTMLInputElement>input).minLength = itemlist[key].constraints.minLength;
                     // } if (itemlist[key].constraints.maxValue != null) {
                     //     (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                     //     (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                     // }
                     (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                     (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                     (<HTMLInputElement>input).maxLength = itemlist[key].constraints.maxLength;
                     (<HTMLInputElement>input).minLength = itemlist[key].constraints.minLength;
                     // (<HTMLInputElement>input).pattern = itemlist[key].constraints.expression;
                  }
                  td.appendChild(input);

               } else if (itemlist[key].dataType === 'd:date') {
                  const input = document.createElement('INPUT');
                  input.setAttribute('type', 'date');
                  input.setAttribute('id', key.toString());
                  input.setAttribute('name', itemlist[key].id);
                  input.style.width = '200px';
                  input.style.borderRadius = '5px';
                  input.style.border = '1px solid #9a9898';
                  input.style.fontSize = '15';
                  if (itemlist[key].value != null) {
                     (<HTMLInputElement>input).value = itemlist[key].value;
                  }
                  if (itemlist[key].mandatory === true) {
                     (<HTMLInputElement>input).required = true;
                  }
                  if (itemlist[key].constraints !== null) {
                     (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                     (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                  }
                  td.appendChild(input);

               } else if (itemlist[key].dataType === 'd:datetime') {
                  const input = document.createElement('INPUT');
                  input.setAttribute('type', 'date');
                  input.setAttribute('id', key.toString());
                  input.setAttribute('name', itemlist[key].id);
                  input.style.width = '200px';
                  input.style.borderRadius = '5px';
                  input.style.border = '1px solid #9a9898';
                  input.style.fontSize = '15';
                  (<HTMLInputElement>input).value = itemlist[key].value;
                  if (itemlist[key].mandatory === true) {
                     (<HTMLInputElement>input).required = true;
                  }
                  if (itemlist[key].constraints !== null) {
                     (<HTMLInputElement>input).max = itemlist[key].constraints.maxValue;
                     (<HTMLInputElement>input).min = itemlist[key].constraints.minValue;
                  }
                  td.appendChild(input);

               }

            }
            tr.appendChild(td);

         }

         div1.appendChild(table);
         document.getElementById('elementItem').appendChild(div1);

      }

   }

   sendProperty(): void {

      const prop = new Object(); // or var map = {};
      // let prop = [];
      // prop.push((<HTMLInputElement>document.getElementById(k.toString())).name + ':::' +
      // (<HTMLInputElement>document.getElementById(k.toString())).value);
      for (let k = 0; k < this.lenght_property; k++) {
         prop[(<HTMLInputElement>document.getElementById(k.toString())).name] =
            (<HTMLInputElement>document.getElementById(k.toString())).value.trim();
      }
      document.getElementById('property').style.display = 'none';
      const listbody = document.getElementsByTagName('TBODY').length;

      if (listbody !== 0) {
         const row = document.getElementsByTagName('TBODY')[0];
         row.parentNode.removeChild(row);
      }

      this.service.editProperties(this.doc_id, prop)
         .subscribe(
            data => {
               this.getDocument();
            },
            error => {
               this.errorMessage = <any>error;
            });
   }

   delElement(): void {
      document.getElementById('property').style.display = 'none';
      const row = document.getElementsByTagName('TBODY')[0];
      row.parentNode.removeChild(row);
   }

   getExpiredDate(expdate: any) {
      return moment(expdate).fromNow();
   }

   getFormatExpiredDate(expdate: any) {
      return moment(expdate).format('DD MMM YYYY HH:mm:ss');
   }

   snackDialog(word: any): void {
      this.success = word;
      const x = document.getElementById('snackbar');
      x.className = 'show';

      setTimeout(() => {
         x.className = x.className.replace('show', '');
      }, 2000);

   }
   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }
   saveDescription(input: string): void {
      if (input !== this.doc.description) {
         // TODO: call PUT /description { id: this.doc.id, description: input.value }
         this.doc.description = input;
         this.service.updateDescription(input, this.doc_id)
            .subscribe(
               data => {
                  // This is intentional.
               },
               error => {
                  this.errorMessage = error;
               });
      }
   }
   getComment(): void {
      this.service.getComment(this.doc_id).subscribe(
         data => {
            this.comment = data.items;
            this.infoPanelConfig = this.setInfoPanelComments(this.comment, this.infoPanelConfig);
         });
   }

   private setInfoPanelComments(comments: zDoxItem["comments"], config = defaultConfig): InfoPanelConfig {
      if(!comments) {
         return {...config};
      }
      const commentsConfig: InfoPanel_Comments = {
         enableCommentsTab: true,
         comments: comments,
         canAdd: this.doc.permissions?.create,
         canEdit: this.doc.permissions,
         canDelete: this.doc.permissions,
      };
      config.tabs.comments = commentsConfig;
      return {...config}
   }

   postComment(input: { content: string; isPostSuccess: (isSuccess: boolean) => void }): void {
      const text = input.content.trim();
      this.service.postComment(this.doc_id, text).subscribe(
         () => {
            this.getComment();
            input.isPostSuccess(true);
         },
         error => {
            input.isPostSuccess(false);
         });
   }

   delComment(item: ViewerInfoPanelComponent["comment"]): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: { service: this.service, item: item }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) { this.comment.splice(i, 1); }
            this.getComment();
         }
      });
   }
   setTypeandProperties(content): void {
      this.service.setTypeandProperties(this.doc_id, content, {})
         .subscribe(
            data => {
               this.getDocument();
            },
            error => {
               this.errorMessage = <any>error.json().message;
            });
   }

   share() {
      this.dialog.open(SharingComponent, {
         disableClose: true,
         data: {
            id: this.doc_id,
            name: this.doc.name,
            service: this.service,
            toast: this.toast,
            role: this.service.role,
            item: this.doc
         }
      });
   }

   startFlow() {
      const siteId = this.getSiteId();
      const pdfTronComp = this.viewerController.fileViewer.pdfTronComp;
      pdfTronComp.isTask = true
      if (!pdfTronComp.isShowSaveBtn) {
         this.startFlowWithPdfConversion(siteId);
      } else {
         pdfTronComp.isCreateTask = true;
         pdfTronComp.isNavigateToCreateTask = true;
         pdfTronComp.flagNoMsg = false;
         pdfTronComp.callbackCreateTask = () => {
            this.startFlowWithPdfConversion(siteId);
            pdfTronComp.isCloseBtnOnBack = true
            pdfTronComp.isNavigateToCreateTask = false;
         };
         this.navigateToCreateTask(siteId);
      }
   }


   /**
    * Site ที่จะใช้เป็นค่า default ของ task ตอน Start Flow คือ site ที่เก็บเอกสารที่เปิดอยู่
    * ต้องเป็นค่าเดียวกับที่ doclist ส่งให้ create-task (tin ของ site หรือ 'My Files')
    * ไม่ใช้ localStorage 'siteCode' เพราะเป็นค่าค้างจากหน้าอื่นและเป็นคนละ id กับ tin
    */
   private getSiteId(): string {
      const siteId = this.doc && this.doc.siteId;
      return !siteId || siteId === 'My File' ? 'My Files' : siteId;
   }

   private startFlowWithPdfConversion(siteId: string) {
      this.service.convertPdfTemplate(this.doc.id)
         .subscribe(data => {
            this.navigateToCreateTask(siteId);
         }, error => {
         });
   }

   navigateToCreateTask(siteId: string) {
      this.router.navigate(['/create-task'],
         {
            queryParams: {
               data: JSON.stringify({
                  item: {
                     id: this.doc.id,
                     isForm: false
                  },
                  typeName: 'startFlow'
               }),
               siteId: siteId || 'My Files'
            }
         });
   }

   openWith() {
      const openOnedrive = () => {
         const dialogRef = this.dialog.open(WaitForImportComponent, {disableClose: true, data: this});
         const waiting = dialogRef.componentInstance;
         waiting.path = this.path;
         this.translate.get('onedrive.open').subscribe(s => {
            waiting.message = s;
         });
         this.service.openwith_onedrive(this.doc.id, window.localStorage.getItem('access_token'))
            .subscribe(data => {
               if (data.webUrl) {
                  window.open(data.webUrl, '_blank');
                  waiting.progress = false;
                  waiting.status = 'pdftron';
                  waiting.id = data.id;
                  waiting.doc_id = this.doc.id;
                  this.translate.get('onedrive.save').subscribe(s => {
                     waiting.message = s;
                  });
                  this.translate.get('onedrive.saveText').subscribe(s => {
                     waiting.saveText = s;
                  });
                  waiting.name = data.name;
                  waiting.isBusiness = this.isBusiness;
                  waiting.update();
               } else {
                  this.findItemAndOpenWithOnedrive(window.localStorage.getItem('access_token'), this.doc, waiting);
               }
            }, error2 => {
               if (error2.status === 401 || (error2.status === 500 && error2.message === 'Stream closed')) {
                  dialogRef.close();
                  localStorage.removeItem('access_token');
                  this.onedrive.signIn('file');
               } else {
                  dialogRef.close();
                  this.toast.error(error2.message);
               }
            });
      }

      if (window.localStorage.getItem('access_token') === null) {
         this.onedrive.signIn('file');
         const loop = setInterval(() => {
            if (window.localStorage.getItem('access_token')) {
               clearInterval(loop);
               openOnedrive();
            }
         },2000);
      } else {
         openOnedrive();
      }
   }

   openWithGoogle() {
      let mimeType;
      if (this.doc.openWithGoogle === 'Google Sheets') {
         mimeType = 'spreadsheets';
      } else {
         mimeType = 'document';
      }
      const next = () => {
         const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this });
         const waiting = dialogRef.componentInstance;
         waiting.path = this.path;
         this.translate.get('googleDoc.open').subscribe(s => {
            waiting.message = s;
         });
         this.service.openwith_google(this.doc.id, this.access_token)
            .subscribe(data => {
               window.open('https://docs.google.com/' + mimeType + '/d/' + data.id + '/edit');
               waiting.progress = false;
               waiting.status = 'pdftron-drive';
               waiting.id = data.id;
               waiting.doc_id = this.doc.id;
               waiting.name = this.doc.name;
               this.translate.get('onedrive.save').subscribe(s => {
                  waiting.message = s;
               });
               this.translate.get('onedrive.saveText').subscribe(s => {
                  waiting.saveText = s;
               });
               waiting.update();
               waiting.isBusiness = this.isBusiness;
               waiting.access_token = this.access_token;
            });
      };
      if (!sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.access_token = sessionStorage.getItem('access_token_google') as string;
            next();
         });
      } else {
         this.access_token = sessionStorage.getItem('access_token_google') as string;
         next();
      }
   }

   saveComment(item: ViewerInfoPanelComponent["comment"], input: string|any) {
      if (input?.trim().length === 0 || input?.value?.trim().length===0) {
         return;
      }
      this.service.put('/comments/' + item.id + '/' + this.doc.id, {content: encodeURIComponent(input)})
         .subscribe(res => {
            item.editing = false;
            item.content = input;
         });
   }

   checkDevice(path, docId) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1) {
         window.location.href = path;
         setTimeout(function() {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1) {
         window.location.href = path;
         setTimeout(function () {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=file?key=' + docId;
         }, 1000);
      }
      this.getDocument();
      this.getComment();
   }

   findZdoxFolderOnOnedrive(token): Promise<any> {
      return new Promise((resolve, reject) => {
         let apps;
         let zdox;
         this.service.onedriveFolders(token).subscribe((res) => {
            apps = res.value.find(e => e.name === 'Apps');
            this.service.onedriveFolders(token, 50, apps.id).subscribe((res) => {
               zdox = res.value.find(e => e.name === 'zDox');
               resolve(zdox.id);
            }, (error) => {
               reject(error);
            });
         }, (error) => {
            reject(error);
         });
      });
   }

   async findItemAndOpenWithOnedrive(token, item, waiting){
      try {
         let zDoxFolder = await this.findZdoxFolderOnOnedrive(token);
         this.service.onedriveListItems(token, zDoxFolder, 50, item.name).subscribe((res) => {
            const resItem = res.value.find(e => e.name === item.name);
            window.open(resItem.webUrl, '_blank');
            waiting.progress = false;
            waiting.status = 'pdftron';
            waiting.id = resItem.id;
            waiting.doc_id = item.id;
            waiting.name = resItem.name;
            this.translate.get('onedrive.save').subscribe(s => {
               waiting.message = s;
            });
            this.translate.get('onedrive.saveText').subscribe(s => {
               waiting.saveText = s;
            });
            waiting.isBusiness = this.isBusiness;
            waiting.update();
         })
      } catch (error) {
      }
   }
}
